import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';
import { ArrowBack } from 'material-ui-icons';
import { routerActions } from 'react-router-redux';
//import { history } from '../../../utils/router';

const styles = theme => ({
  flex: {
    flex: 1,
  },
  root: {
    backgroundColor: theme.palette.background.default,
  },
  appBar: {
    maxWidth: 1040,
    margin: '0 auto',
  },
  headSpan: {
    paddingRight: theme.spacing.unit * 2,
  },
  subheading: {
    display: 'inline-block',
    fontSize: 16,
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: theme.spacing.unit,
    paddingLeft: 0,
  },
  backButton: {
    marginLeft: -theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
  },
});

class Bar extends Component {
  static propTypes = {
    backPath: PropTypes.string,
    classes: PropTypes.object,
    replace: PropTypes.func,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  };

  onBackClick = () => {
    const { backPath, replace, goBack } = this.props;
    if (backPath) replace(backPath);
    else goBack();
  };

  render() {
    const { classes, title, subtitle } = this.props;

    if (classes.backButton.indexOf('pdfHide') < 0) {
      classes.backButton = classes.backButton + ' pdfHide';
    }

    return (
      <div className={classes.root}>
        <AppBar className={classes.appBar} elevation={0} position="static">
          <Toolbar>
            <IconButton className={classes.backButton} color="contrast" aria-label="Back" onClick={this.onBackClick}>
              <ArrowBack />
            </IconButton>
            <Typography className={classes.flex} type="title" color="inherit">
              <span className={classes.headSpan}>{title}</span>
              {subtitle && (
                <div className={classes.subheading} type="subheading" color="inherit">
                  {subtitle}
                </div>
              )}
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const ConnectedAppBar = connect(mapStateToProps, routerActions)(Bar);

export default withStyles(styles)(ConnectedAppBar);



// WEBPACK FOOTER //
// ./src/modules/core/components/PageAppBar.js